var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import "./number.input.css";
import { numeric } from "../core/numeric";
import { EventHandler } from "../interaction/eventhandler";
var defaultOptions = { format: "0.###", formatOnBlur: true, commitOnEnter: true, placeholder: false, enabled: true };
export function NumberInput(input, options) {
    var el;
    var o = __assign(__assign({}, defaultOptions), options);
    o.onChange = EventHandler.Create(o.onChange);
    if (typeof input === "string") {
        el = document.querySelector(input);
    }
    else {
        el = input;
    }
    if (o.value || o.value === 0) {
        el.value = numeric.format(o.value, o.format);
    }
    if (o.placeholder !== false) {
        if (o.placeholder === true) {
            el.placeholder = numeric.format(0, o.format);
        }
        else {
            el.placeholder = o.placeholder;
        }
    }
    el.classList.add("jsl-number");
    if (o.enabled === false) {
        el.setAttribute("disabled", "disabled");
    }
    else {
        if (o.formatOnBlur) {
            el.addEventListener("blur", function (evt) {
                var val = numeric.parse(el.value);
                el.value = numeric.format(val, o.format);
            });
        }
        if (o.onChange != null) {
            el.addEventListener("change", function (evt) {
                o.onChange.notify(numeric.parse(el.value));
            });
        }
        el.addEventListener("keydown", function (evt) {
            if (evt.which === 13) {
                if (o.formatOnBlur) {
                    var val = numeric.parse(el.value);
                    el.value = numeric.format(val, o.format);
                }
                o.onChange.notify(numeric.parse(el.value));
            }
        });
    }
    return el;
}
